import React, { Component, Fragment } from 'react'
import classnames from 'classnames'

import { Div } from '@driftt/tide-core'
import { Table } from '@driftt/tide-table'
import { AccountSidebar } from '@driftt/account-detail'

import { formatAccountDataForTable } from './cellFormatter'
import './style.css'

class AccountsTable extends Component {

  state = {
    isSideBarOpen: false,
    selectedId: null
  }

  closeSideBar = () => {
    this.setState({
      isSideBarOpen: false
    })
  }

  openSideBar = id => {
    this.setState({
      isSideBarOpen: true,
      selectedId: id
    })
  }

  onToggleSelect = (checked, index) => {
    const { selectRow, removeRow } = this.props
    const operation = checked ? selectRow : removeRow

    operation(index)
  }

  setStickyHeader = (event) => {
    const { hasScrolled } = this.state
    const scrollingElement = event.target

    const offset = scrollingElement.scrollTop

    if (!hasScrolled && offset > 20) {
      this.setState({
        hasScrolled: true
      })
    } else if (hasScrolled && offset === 0) {
      this.setState({
        hasScrolled: false
      })
    }
  }

  render() {
    const { accounts, users, hasFinished, openEdit, openDelete, columns, selectedRows, isWorking } = this.props
    const { isSideBarOpen, selectedId, hasScrolled } = this.state

    return (
      <Fragment>
        <Div className={classnames('accounts-table-container', {'accounts-table-container--stick': hasScrolled})} onScroll={this.setStickyHeader}>
          <Table
            isWorking={isWorking}
            className={classnames("accounts-table", {
              'accounts-table--loaded': hasFinished,
              'accounts-table--is-working': isWorking
            }) }
            data={formatAccountDataForTable(
              accounts,
              users,
              selectedRows,
              openEdit,
              openDelete,
              this.openSideBar,
              this.onToggleSelect
            )}
            columns={columns}
          />
        </Div>
        <AccountSidebar
          isOpen={isSideBarOpen}
          close={this.closeSideBar}
          id={selectedId}
          notify={() => {}}
        />
      </Fragment>
    )
  }
}

export default AccountsTable
